import type { components } from "@/api-schema";
import { RelocationOrderStatus, RelocationOrderTransportMethod } from "@/api-schema-enums";
import { RELOCATION_ORDER_STATUS_FILTER_OPTIONS } from "@/components/filter/predefined/relocation-order-status-filter";
import { BLOCKABLE_RELOCATION_STATUSES } from "@/common/helpers/vehicle-is-blockable";
import { OWN_AXLE_ALLOWED_STATUSES } from "@/modules/fit/internal/relocation-order/admin/_constants/relocation-order-statuses";

type VehicleBlock = components["schemas"]["VehicleBlock"];

const MANUAL_MANAGEMENT_EXCLUDED_VEHICLE_LOCATION_STATUSES: readonly RelocationOrderStatus[] = [
  RelocationOrderStatus.TransportCompanyAwaitingDeliveryAcceptance,
  RelocationOrderStatus.TransportCompanyRestAtLayover,
];

export interface GetAvailableStatusesParams {
  vehicleBlock?: VehicleBlock | null;
  /** Statuses that stay selectable even if the rules below exclude them, e.g. the order's saved status. */
  keepStatuses?: RelocationOrderStatus[];
  transportMethod?: RelocationOrderTransportMethod;
}

export function getAvailableStatuses({
  vehicleBlock,
  keepStatuses = [],
  transportMethod,
}: GetAvailableStatusesParams): RelocationOrderStatus[] {
  const vehicleIsBlocked = !!vehicleBlock;

  let statuses: RelocationOrderStatus[];
  if (vehicleIsBlocked) {
    statuses = [...BLOCKABLE_RELOCATION_STATUSES];
  } else {
    statuses = Object.values(RELOCATION_ORDER_STATUS_FILTER_OPTIONS).map((option) => option.id);
  }

  statuses = statuses.filter((status) => !MANUAL_MANAGEMENT_EXCLUDED_VEHICLE_LOCATION_STATUSES.includes(status));

  if (transportMethod === RelocationOrderTransportMethod.OwnAxle) {
    statuses = statuses.filter((status) => OWN_AXLE_ALLOWED_STATUSES.includes(status));
  }

  const missingKeepStatuses = [...new Set(keepStatuses)].filter((status) => !statuses.includes(status));

  return [...missingKeepStatuses, ...statuses];
}
